import sidebarDownIcon from '../../assets/sidebar/SidebarDown.svg';
import sidebarUpIcon from '../../assets/sidebar/SidebarUp.svg';
import SidebarIcon from './SidebarIcon';
import SidebarItem from './SidebarItem';
import type { SidebarMenuSection } from './sidebarTypes';

type SidebarSectionProps = {
  section: SidebarMenuSection;
  activePath: string;
  expanded: boolean;
  onToggle: () => void;
};

function SidebarSection({ section, activePath, expanded, onToggle }: Readonly<SidebarSectionProps>) {
  const hasItems = section.items.length > 0;
  const itemCount = section.items.length;

  return (
    <section className="nav-section">
      <button
        aria-expanded={expanded}
        className="nav-heading"
        onClick={onToggle}
        type="button"
      >
        <span className="heading-left">
          <SidebarIcon name={section.icon} />
          <span>{section.title}</span>
        </span>
        <span className="heading-right">
          {hasItems && <span className="count">{itemCount}</span>}
          {hasItems && (
            <img
              alt=""
              aria-hidden="true"
              className="sidebar-chevron"
              src={expanded ? sidebarUpIcon : sidebarDownIcon}
            />
          )}
        </span>
      </button>

      {hasItems && expanded && (
        <div className="subnav">
          {section.items.map((item) => (
            <SidebarItem active={item.path.split('?')[0] === activePath} item={item} key={item.label} />
          ))}
        </div>
      )}
    </section>
  );
}

export default SidebarSection;
